import i18n from '@/plugins/i18n';

const usageGraphs = () => ({
  lineCharts: [
    {
      width: '100%',
      isUsages: true,
      title: i18n.global.t('active-sessions'),
      header: {
        title: i18n.global.t('active-sessions'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
        displayOnlyUnit: false,
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#98ED78'],
      height: '12.5em',
      entityType: 'Mobile',
      independentSelector: false,
      sortOrder: 'DES',
      metricType: 'REGULAR_VALUE',
      metricName: 'mobile',
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'activeUsersByOs',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('cpmWithFullForm'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('number-of-sessions'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
    {
      width: '100%',
      title: i18n.global.t('newUsers'),
      isUsages: true,
      header: {
        title: i18n.global.t('newUsers'),
        titleIcon: '',
        content: [],
        displayOnlyUnit: false,
        displayCustomButton: false,
        HideCenterMiscContent: true,
      },
      chartColor: ['#ed7878'],
      height: '12.5em',
      entityType: 'Mobile',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'mobile',
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'newRegisteredUsers',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('ms-average'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('number-of-users'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
  ],
  lineChartsRight: [
    {
      width: '100%',
      title: i18n.global.t('appLaunches'),
      isUsages: true,
      header: {
        title: i18n.global.t('appLaunches'),
        titleIcon: '',
        content: [],
        displayOnlyUnit: false,
        displayCustomButton: false,
        HideCenterMiscContent: true,
      },
      chartColor: ['#FF8022'],
      height: '12.5em',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'mobile',
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'appEventsByOs',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('ms-average'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('number-of-app-launches'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
  ],
  areaCharts: [
    {
      width: '100%',
      widthInPer: '100%',
      title: i18n.global.t('usage-by-os'),
      height: '12.5em',
      header: {
        title: i18n.global.t('usage-by-os'),
        titleIcon: '',
        content: [],
        toolbar: true,
        HideCenterMiscContent: true,
      },
      chartColor: ['#FF056E', '#FF9520'],
      entityType: 'Endpoint',
      independentSelector: false,
      filterType: 'Os',
      metricType: 'LABELED_VALUE',
      metricName: '-',
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'usage',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: 'ms',
      metricLabels: 'iOS, Android',
      labelsIndex: '0, 1',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('number-of-users'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
      showLegendForSingle: true,
      responseType: 'dynamic',
    },
  ],
  areaChartsRight: [
    {
      width: '100%',
      widthInPer: '100%',
      title: i18n.global.t('app-version-distribution-top-4'),
      height: '12.5em',
      filterType: 'AppVersion',
      header: {
        title: i18n.global.t('app-version-distribution-top-4'),
        titleIcon: '',
        content: [],
        toolbar: true,
        HideCenterMiscContent: true,
      },
      chartColor: ['#E63A46', '#F843DD', '#FAB025', '#5DC167', '#00CEFF'],
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: '-',
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'usage',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'ms',
      metricLabels: 'Resources, Js, Ajax, Unknown',
      labelsIndex: '0, 1, 2, 3',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('number-of-users'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
      showLegendForSingle: true,
      responseType: 'dynamic',
    },
    {
      width: '100%',
      widthInPer: '100%',
      title: i18n.global.t('usage-by-device-top-5'),
      height: '12.5em',
      filterType: 'Device',
      header: {
        title: i18n.global.t('usage-by-device-top-5'),
        titleIcon: '',
        content: [],
        toolbar: true,
        HideCenterMiscContent: true,
      },
      chartColor: ['#E63A46', '#F843DD', '#FAB025', '#5DC167', '#00CEFF'],
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: '-',
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'usage',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'ms',
      metricLabels: 'Resources, Js, Ajax, Unknown',
      labelsIndex: '0, 1, 2, 3',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('number-of-users'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
      showLegendForSingle: true,
      responseType: 'dynamic',
    },
  ],
});
export default usageGraphs;
